import comp from "./SelectStandardsModal";
export default comp;
